import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Services/apiService';
import { apiUrl, publicCoursePath } from '../../config/api';
import './CourseTypes.css';

const CourseType = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    fetchData(apiUrl('All/Offerings'))
      .then((data) => setCourses((data || []).filter((course) => Number(course.show_on_home) === 1)))
      .catch((error) => console.error('Unable to load course offerings:', error));
  }, []);

  return (
    <section className="home-programs">
      <div className="home-programs__heading">
        <span className="home-programs__eyebrow">Learn. Trade. Grow.</span>
        <h2 className="home-programs__title">Our Programs</h2>
        <p>Practical market education designed to help you invest with clarity and confidence.</p>
      </div>
      <div className="container home-programs__container">
        <div className="row home-programs__grid">
        {courses.map((course) => (
          <div className="col-md-6 col-lg-4 home-programs__column" key={course.course_type}>
            <Link to={publicCoursePath(course.course_type)} className="home-programs__card" aria-label={`Explore ${course.title}`}>
              <div className="home-programs__image-wrap">
                <img src={course.image_url} className="home-programs__image" alt="" />
                {course.course_type && <span className="home-programs__level">{course.course_type}</span>}
              </div>
              <div className="home-programs__card-content">
                <h3>{course.title}</h3>
                <p>{course.subtitle}</p>
                <span className="home-programs__link-text">Explore program <span aria-hidden="true">→</span></span>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
};

export{CourseType};
